import Typography from '@material-ui/core/Typography';
import React from 'react';

import PatientOverviewLink from 'src/components/general/patientOverviewLink';

const notes = {
  type: 'string',
  uniforms: {
    multiline: true,
  },
};

export default {
  type: 'object',
  title: 'Prescriber: Subjective (Initial)',
  properties: {
    reviewedSubstanceUse: {
      type: 'boolean',
      title: 'Reviewed/updated "Substance use"',
      label: (
        <span>
          Reviewed/updated{' '}
          <PatientOverviewLink section="substanceUse">
            &ldquo;Substance Use&rdquo;
          </PatientOverviewLink>
        </span>
      ),
    },
    reviewedMedical: {
      type: 'boolean',
      title: 'Reviewed/updated "Medical"',
      label: (
        <span>
          Reviewed/updated{' '}
          <PatientOverviewLink section="medical">&ldquo;Medical&rdquo;</PatientOverviewLink>
        </span>
      ),
    },
    experienceBuprenorphine: {
      type: 'string',
      title: 'Experience with Buprenorphine',
      enum: ['Yes', 'No'],
    },
    buprenorphineAllergy: {
      type: 'string',
      title: 'Allergy to Buprenorphine',
      enum: ['Yes', 'No'],
    },
    infectionConcern: {
      type: 'object',
      title: 'Concern for infection related to use',
      format: 'selectable',
      renderer: {
        component: ({ model, classes }) => (
          <>
            {model.infectionConcern.selectionKey === 'yes' && (
              <>
                <span>Yes</span>
                {model.infectionConcern.additional && (
                  <Typography variant="body2" className={classes.multiLineText}>
                    {model.infectionConcern.additional.notes}
                  </Typography>
                )}
              </>
            )}
            {model.infectionConcern.selectionKey === 'no' && <span>No</span>}
          </>
        ),
      },
      properties: {
        yes: {
          type: 'object',
          properties: {
            notes,
          },
        },
        no: true,
      },
    },
    otherConcerns: {
      title: 'Other concerns today',
      ...notes,
    },
    previousUsage: {
      type: 'integer',
      min: 0,
      max: 30,
      title: 'Previous month opioid usage (days)',
      tooltip:
        '"Of the last 30 days, how many have you used opioids (other than any prescribed medications)?"',
      uniforms: {
        fullWidth: true,
        margin: 'dense',
      },
    },
    notes,
  },
  required: [],
};
